import React, { useMemo } from 'react';
import { Table } from 'react-bootstrap';
import CustomModal from '../../Global/Modal/CustomModal';

const PackageUsersModal = ({ show, handleClose, users, packageType }) => {
    const getPackageName = (type) => {
        switch (type) {
            case 'gold':
                return 'זהב';
            case 'silver':
                return 'כסף';
            case 'bronze':
                return 'ארד';
            default:
                return type;
        }
    };

    const getPackageColor = (type) => {
        switch (type) {
            case 'gold':
                return '#FFD700';
            case 'silver':
                return '#C0C0C0';
            case 'bronze':
                return '#CD7F32';
            default:
                return '#000000';
        }
    };

    const getStatusBadge = (status) => {
        switch (status) {
            case 'active':
                return <span className="text-success">פעיל</span>;
            case 'inactive':
                return <span className="text-danger">לא פעיל</span>;
            case 'suspended':
                return <span className="text-warning">מושעה</span>;
            default:
                return <span className="text-muted">לא ידוע</span>;
        }
    };

    const formatDateTime = (date) => {
        if (!date) return 'לא ידוע';

        try {
            let dateObj;
            if (date.toDate) {
                dateObj = date.toDate();
            } else if (typeof date === 'number') {
                dateObj = new Date(date);
            } else if (typeof date === 'string') {
                dateObj = new Date(date);
            } else if (date.seconds) {
                dateObj = new Date(date.seconds * 1000);
            } else {
                return 'לא ידוע';
            }

            return dateObj.toLocaleString('he-IL', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                hour12: false
            });
        } catch (error) {
            console.error('Error formatting date:', error);
            return 'לא ידוע';
        }
    };

    const getDateValue = (date) => {
        if (!date) return 0;
        try {
            if (date.toDate) {
                return date.toDate().getTime();
            } else if (typeof date === 'number') {
                return date;
            } else if (typeof date === 'string') {
                return new Date(date).getTime();
            } else if (date.seconds) {
                return date.seconds * 1000;
            }
        } catch (error) {
            console.error('Error getting date value:', error);
        }
        return 0;
    };

    const sortedUsers = useMemo(() => {
        return [...users].sort((a, b) => {
            const dateA = getDateValue(a.userCreatedAt);
            const dateB = getDateValue(b.userCreatedAt);
            return dateB - dateA; // Descending order (newest first)
        });
    }, [users]);

    const title = (
        <div className="d-flex align-items-center">
            משתמשי חבילת {getPackageName(packageType)}
            <span
                style={{
                    backgroundColor: getPackageColor(packageType),
                    padding: '2px 8px',
                    borderRadius: '4px',
                    marginRight: '8px',
                    color: packageType === 'silver' ? '#000' : '#fff',
                }}
            >
                {packageType.toUpperCase()}
            </span>
        </div>
    );

    const footerButtons = [
        {
            title: 'סגור',
            style: 'grey',
            onClick: handleClose
        }
    ];

    return (
        <CustomModal
            isOpen={show}
            onClose={handleClose}
            title={title}
            width={80}
            height={80}
            footerButtons={footerButtons}
        >
            <div className="p-3">
                <Table striped bordered hover responsive>
                    <thead>
                        <tr>
                            <th>שם משתמש</th>
                            <th>אימייל</th>
                            <th>סטטוס</th>
                            <th>תאריך הצטרפות</th>
                            <th>התחברות אחרונה למערכת</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sortedUsers.map((user) => (
                            <tr key={user.id}>
                                <td>{user.userName || 'ללא שם'}</td>
                                <td>{user.userEmailAddress || 'ללא אימייל'}</td>
                                <td>{getStatusBadge(user.userStatus)}</td>
                                <td>{formatDateTime(user.userCreatedAt)}</td>
                                <td>{formatDateTime(user.lastLoginAt)}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
        </CustomModal>
    );
};

export default PackageUsersModal; 